import { Component } from '@angular/core';
import { NavParams, AlertController, ToastController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';

@Component({
  selector: 'event-map',
  templateUrl: 'event-map.html'
})
export class EventMapComponent {

  obsMap: any;
  obsListener: any;
  event: any;
  client: string;
  componentState: boolean = false;
  dataMap: any = false;
  // Default office in Bogota
  zoom: number = 15;
  lat: number = 4.6810459;
  lng: number = -74.0644026;

  constructor(public eventProvider: EventData, public params: NavParams, public alertCtrl: AlertController, public toastCtrl: ToastController, events: Events) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'map').subscribe(stateModule => {
      this.closeListener(true);

      if (stateModule.$value === true) {
        this.obsMap = this.eventProvider.getMap(this.client, this.event.id).subscribe((data) => {
          this.dataMap = data;

          setTimeout(() => {
            this.lat = parseFloat(this.dataMap.latitude);
            this.lng = parseFloat(this.dataMap.longitude);
            this.zoom = parseFloat(this.dataMap.zoom);
          }, 1500)

          this.componentState = true;
        });
      } else {
        this.dataMap = false;
        this.componentState = false;
        console.log("Módulo Map deshabilitado");
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  closeListener(primaryListener = false) {
    if (this.obsListener && !primaryListener) {
      console.log('Se eliminan los observables de Map');
      this.obsListener.unsubscribe();
    }
    if (this.obsMap) {
      this.obsMap.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}



// WEBPACK FOOTER //
// ./src/components/event-map/event-map.ts